/** @flow */

import {
  GetWellbeingServicesList,
  GetWellbeingServicesListSuccess,
  GetWellbeingServicesListError,
  SetShowAddWellbeingServiceModal,
  NewWellbeingServiceAssignments,
  SetWellbeingServiceSchema,
  GetWellbeingServiceDetails,
  GetWellbeingServiceDetailsSuccess,
  GetWellbeingServiceDetailsError,
  SetWellbeingServiceDraft,
  SetWellbeingServiceAssignments,
  SetShowEditWellbeingServiceModal,
  ShowEditAssignmentsModal,
  SetWellbeingServiceDraftAssignments,
  AddWellbeingService,
  AddWellbeingServiceSuccess,
  AddWellbeingServiceError,
  EditWellbeingService,
  EditWellbeingServiceSuccess,
  EditWellbeingServiceError,
  SetWellbeingServiceCurrentDetails,
} from "@modules/service/constants/actions";
import * as wellbeingServicesReducers from "./reducers";
import initialState from "./state";
import type { WellbeingServicesState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: WellbeingServicesState = initialState,
  action: Object,
): WellbeingServicesState => {
  const act = {
    [GetWellbeingServicesList]: wellbeingServicesReducers.setLoading,
    [GetWellbeingServicesListSuccess]: wellbeingServicesReducers.onGetWellbeingServicesListSuccess,
    [GetWellbeingServicesListError]: wellbeingServicesReducers.onGetWellbeingServicesListError,

    [GetWellbeingServiceDetails]: wellbeingServicesReducers.setLoading,
    [GetWellbeingServiceDetailsSuccess]:
      wellbeingServicesReducers.onGetWellbeingServiceDetailsSuccess,
    [GetWellbeingServiceDetailsError]: wellbeingServicesReducers.onError,

    [AddWellbeingService]: wellbeingServicesReducers.setLoading,
    [AddWellbeingServiceSuccess]: wellbeingServicesReducers.setLoaded,
    [AddWellbeingServiceError]: wellbeingServicesReducers.onError,

    [EditWellbeingService]: wellbeingServicesReducers.setLoading,
    [EditWellbeingServiceSuccess]: wellbeingServicesReducers.setLoaded,
    [EditWellbeingServiceError]: wellbeingServicesReducers.onError,

    [SetWellbeingServiceCurrentDetails]:
      wellbeingServicesReducers.onSetWellbeingServiceCurrentDetails,
    [SetWellbeingServiceDraft]: wellbeingServicesReducers.onSetWellbeingServiceDraft,
    [SetWellbeingServiceSchema]: wellbeingServicesReducers.onSetWellbeingServiceSchema,

    [SetShowAddWellbeingServiceModal]: wellbeingServicesReducers.onSetShowAddWellbeingServiceModal,
    [SetShowEditWellbeingServiceModal]:
      wellbeingServicesReducers.onSetShowEditWellbeingServiceModal,
    [ShowEditAssignmentsModal]: wellbeingServicesReducers.onShowEditAssignmentsModal,

    [NewWellbeingServiceAssignments]: wellbeingServicesReducers.onNewWellbeingServiceAssignments,
    [SetWellbeingServiceAssignments]: wellbeingServicesReducers.setWellbeingServiceAssignments,
    [SetWellbeingServiceDraftAssignments]:
      wellbeingServicesReducers.onSetWellbeingServiceDraftAssignments,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
